import { AdminHomePanelProps } from './admin-home-panel-props';
import loadable from '@loadable/component';

export const AsyncAdminHomePanel = loadable<AdminHomePanelProps>((): any =>
  import('./admin-home-panel'),
);
